import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();
const DEFAULT_THEME = "patriot-light";

const themes = [
  { id: "dark-blue", name: "Dark Blue" },
  { id: "dark-black", name: "Dark Black" },
  { id: "veterans-journey", name: "Veteran's Journey" },
  { id: "cyberpunk", name: "Cyberpunk" },
  { id: "stellar-drift", name: "Stellar Drift" },
  { id: "nebula-ember", name: "Nebula Ember" },
  { id: "deep-space-ice", name: "Deep Space Ice" },
  { id: "midnight-orbit", name: "Midnight Orbit" },
  { id: "patriot-light", name: "Patriot Light" },
  { id: "executive-light", name: "Executive Light" },
  { id: "clean-slate", name: "Clean Slate" },
  { id: "soft-cloud", name: "Soft Cloud" },
  { id: "harbor-blue", name: "Harbor Blue" },
  { id: "sandstone", name: "Sandstone" },
  { id: "evergreen-mist", name: "Evergreen Mist" },
];

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(DEFAULT_THEME);

  useEffect(() => {
    if (theme !== DEFAULT_THEME) {
      setTheme(DEFAULT_THEME);
      return;
    }

    localStorage.removeItem("fvg-theme");
    document.documentElement.setAttribute("data-theme", DEFAULT_THEME);
  }, [theme]);

  return <ThemeContext.Provider value={{ theme, setTheme, themes }}>{children}</ThemeContext.Provider>;
};
